export const STATUS_KEYS = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  REQUESTED: "REQUESTED",
  TERMINAL_APPROVED: "TERMINAL_APPROVED",
  OPERATIONS_APPROVED: "OPERATIONS_APPROVED",
  HSE_APPROVED: "HSE_APPROVED",
  MD_APPROVED: "MD_APPROVED",
  STARTED: "STARTED",
  REJECTED: "REJECTED",
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED",
  COMPLETED: "COMPLETED",
};
